import { useContext, createContext, useState } from 'react';
import { authApi } from '../configs/axiosConfig'
import { defineCancelApiObject } from '../configs/axiosUtils'

import { useNavigate } from 'react-router-dom'

const AuthContext = createContext();
const authMethod = (methodName) => {
    return "/Autenticacao" + methodName;
}


const AuthProvider = ({ children }) => {
    const [user, setUser] = useState({});
    const navigate = useNavigate();

    const verifyLogin = async(handleVerifyLogin, errorHandle, cancel, notLogoutOnVerify) =>{
        try {
            const response = await authApi.request({
                url: authMethod("/verify"),
                method: 'GET',
                withCredentials: true,
                signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
            });

            const res = await response;
            if(res.status === 200){
                if(handleVerifyLogin)
                    handleVerifyLogin(res.data.data);
                return true;
            }
            
            if(!notLogoutOnVerify)
                return false;

            await logOut();
            return false;

        } catch (responseError) {
            if(errorHandle)
                errorHandle(responseError);
            if(responseError.response){
                if(!notLogoutOnVerify)
                    return false;
                await logOut();
                return false;
            }            
            console.error(responseError);
            return false;
        }
    };

    const loginAction = async (data, errorHandle, cancel) => {
        try {
            const response = await authApi.request({
                url: authMethod("/login"),
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                data: data,
                withCredentials: true,
                signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
            });

            const res = await response;
            const responseData = res.data;
            
            if (responseData) {
                setUser(responseData.data.data);
                navigate("/home");
                return;
            }
        } catch (err) {
            errorHandle(err);
            console.error(err);
        }
    };

    const logOut = async (errorHandle, cancel) => {
        try {
            const response = await authApi.request({
                url: authMethod("/logout"),
                method: 'POST',
                withCredentials: true,
                signal: cancel ? cancelApiObject[this.get.name].handleRequestCancellation().signal : undefined,
            });

            await response;            
            setUser({});
            navigate("/login");
            return false;

        } catch (responseError) {
            if(errorHandle)
                errorHandle(responseError);
            
            setUser({});
            navigate("/login");
            console.error(responseError);

            return false;
        }
        
    };

    return (
        <AuthContext.Provider value={{ user, loginAction, verifyLogin, logOut }}>
            {children}
        </AuthContext.Provider>
    );

};

export default AuthProvider;

const cancelApiObject = defineCancelApiObject(AuthProvider)

export const useAuth = () => {
    return useContext(AuthContext);
};
